import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class SnChannelSettings extends SnModel {
  @Expose()
  @Default(false)
  public hideSystemNotifications: boolean;

  @Expose()
  public isMuted: boolean;

  @Expose()
  public schedules: any;

  @Expose()
  public snoozeCreated: string;

  @Expose()
  public snoozeDuration: number;

  constructor(data?: any) {
    super();
    this.fromJSON(data);
  }
}
